/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

/** Figma check (8×6 viewBox); stroke matches #4D4C4C via currentColor. */
const ToggleCheckIcon = ({ className = '', size = 12 }) => (
  <svg
    className={className}
    width={size}
    height={(size * 6) / 8}
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path d="M7 1L3 5L1 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

ToggleCheckIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};

export default ToggleCheckIcon;
